import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './quotes.css'; 
import { DataGrid,
         GridActionsCellItem,
         GridRowModes,
 } from '@mui/x-data-grid';
import {
  Box,
  Collapse,
  Typography,
  CircularProgress,
  Paper
} from '@mui/material';

import { Edit, Delete, Add } from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';


import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add'; // Import the Add icon
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';


import { Link } from 'react-router-dom';
import { authFetch } from './utils/api';
import { authFetchRequest } from './utils/api';
import AddItem from './additem';
import MenuView from './menuview';
import CmbCustomers from './CmbCustomers'; 
import NewCustomerDialog from './NewCustomerDialog';
import { getFilterForUser } from './utils/utils';
import { getStatusFilterForUser } from './utils/utils';

import { getCookie } from './utils/cookies';
import { alertC, confirmC } from './components/dialogService';

const Orders = () => {
  const location = useLocation();
  const { quoteId: selectedQuoteFromNav } = location.state || {};
  
  const [quotes, setQuotes] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [itemQuotes, setItemQuotes] = useState({});
  const [loadingItemQuotes, setLoadingItemQuotes] = useState(false);

  const [loading, setLoading] = useState(true);
  const [rowModesModel, setRowModesModel] = useState({});

  const [showCustomerCombo, setShowCustomerCombo] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [visible, setVisible] = useState(true);

  const [showDialog, setShowDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  //=> handle add new customer
  const handleAddNewCustomer = () => {
    setShowDialog(true);
  };
  const handleSaveCustomer = (newCustomer) => {
    setSelectedCustomer(newCustomer); // Optionally update the dropdown selection
    setShowDialog(false);
  };
  //=> end of handle add new customer

  // Inline editing
  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

const processRowUpdate = async (newRow) => {
  try {
      const updatedRow = await authFetchRequest(
          `/quotes/${newRow.id}`,
          newRow,
          "PUT",
          { Authorization: `Bearer ${getCookie("access_token")}` } // Example of adding a header dynamically
      );

      setQuotes((prev) => prev.map((row) => (row.id === newRow.id ? updatedRow : row)));

      setRowModesModel((prev) => ({
          ...prev,
          [newRow.id]: { mode: GridRowModes.View },
      }));

      return updatedRow;
  } catch (error) {
      console.error("Failed to update row:", error);
      alert(`Failed to update row: ${error.message}`);
      return newRow;
  }
};
// Delete row
  const handleDeleteClick = (id) => async () => {
    try {
      const row = quotes.find((r) => r.id === id);
      if (!row) {
        await alertC("Row not found for ID:", id);
        return;
      }
      if (parseInt(getCookie('user_id')) !== parseInt(row.fkUserId)) {
        await alertC("You don't have permission to delete this item.");
        return;
      } 
      const confirmed = await confirmC("Are you sure you want to delete this line?");
      if (!confirmed) return;
      await authFetchRequest(`/quotes/${id}`, null, "DELETE");
      setQuotes((prevRows) => prevRows.filter((row) => row.id !== id));
      console.log(`Line ${id} deleted`);
      setExpandedRow(null);
    } catch (err) {
      console.error("Delete failed:", err);
      await alertC("Failed to delete line: " + err.message);
    }
  };

const handleSubmitQuote = async () => {   
    const confirmed = await confirmC("Are you sure you want to submit this quote?\nThis operation is irreversible.");
      if (!confirmed) return;
  try {
      const user = localStorage.getItem("user");
      const selectedQuote = quotes.find(q => q.id === expandedRow);
      //alert(JSON.stringify(selectedQuote, null, 2));
      const quoteId = selectedQuote?.id;
      const new_status = "Quote Submitted";
      const payload = {
        current_status : selectedQuote?.status,
        new_status: new_status,
        created_by: user
      }

      const response = await authFetchRequest(
      `/quotes/${quoteId}/transition`,
      payload,
      "POST",
      { Authorization: `Bearer ${getCookie("access_token")}` }
    );

    console.log("Quote submitted:", response);
    setQuotes(prevQuotes => prevQuotes.filter(q => q.id !== quoteId));

    await alertC("Quote Submitted");
  } catch (err) {
    console.error("Failed to submit quote:", err);
    alert("Failed to submit quote: " + err.message);
  }
}



const handleCreateQuote = async () => {
  if (!selectedCustomer) return;

  const confirmed = await confirmC("Are you going to create order?");
  if (!confirmed) return;

  try {
    const user = localStorage.getItem("user");
    const timestamp = new Date().toISOString();

    const payload = {
      quote_name: `Quote for ${selectedCustomer.name}`,
      fkCustomerId: selectedCustomer.id,
      created_at: timestamp,
      reference_no: "",
      created_by: user || "Unknown",
      tags: "",
      status: "Quote",
    };

    const response = await authFetchRequest(
      `/quotes/`,
      payload,
      "POST",
      { Authorization: `Bearer ${getCookie("access_token")}` }
    );

    console.log("Quote created:", response);
    setQuotes(prevQuotes => [response, ...prevQuotes]);
    // Optional: navigate or show confirmation
  } catch (err) {
    console.error("Failed to create quote:", err);
    alert("Failed to create quote: " + err.message);
  }
};


  const handleAddQuoteClick = () => {
    setShowCustomerCombo(true); // show the combo
  };
  const handleCustomerChange = (customer) => {
    setSelectedCustomer(customer);
    console.log('Selected customer:', customer);
    // optionally trigger more UI here
  };

  const handleCreateQuoteClick = () => {
    // Logic to create a quote, for example, opening a quote form
    console.log('Creating quote for', selectedCustomer.name);
  };

  const handleHideClick = () => {
    setVisible(false);
    setShowCustomerCombo(false);
  };

  useEffect(() => {
    if (selectedQuoteFromNav) {
      setExpandedRow(selectedQuoteFromNav);
      fetchItemQuotes(selectedQuoteFromNav);
    }
  }, [selectedQuoteFromNav]);
  
  // Load quotes on mount
  useEffect(() => {
  
    const filter = getFilterForUser();
    const status = getStatusFilterForUser('Quote')
    authFetch(`/quotes/quotesbyuser/${filter}${status}`)
      //.then(setQuotes)
    .then(data => {
      const filteredQuotes = data.filter(q => q.status !== "Quote"); // Filtering out "Quote" entries
      setQuotes(filteredQuotes);
    })
      .catch(err => {
        console.error('Failed to fetch quotes:', err);
        // Handle unauthorized (redirect to login if 401)
        if (err.message.includes('401')) {
          handleLogout();
        }
      });
  }, []);

  // Fetch item quotes for selected quote
  const fetchItemQuotes = async (quoteId) => {
    setLoadingItemQuotes(true);
    try {
      const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
      setItemQuotes(prev => ({ ...prev, [quoteId]: data }));
    } catch (err) {
      console.error('Failed to fetch item quotes:', err);
      setItemQuotes(prev => ({ ...prev, [quoteId]: [] }));
      if (err.message.includes('401')) {
        handleLogout();
      }
    } finally {
      setLoadingItemQuotes(false);
    }
  };

  // Handle row click
  const handleRowClick = (params) => {
    const quoteId = params.id;
    if (expandedRow === quoteId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(quoteId);
      if (!itemQuotes[quoteId]) fetchItemQuotes(quoteId);
    }
  };

  // DataGrid columns
  const columns = [
    { field: 'id', headerName: 'ID', width: 90, editable: false },
    { field: 'quote_name', headerName: 'Order Name', width: 250, editable: true },
    //{ field: 'fkCustomerId', headerName: 'Customer ID', width: 100},
    { field: 'customer_name', headerName: 'Customer', width: 100, editable: false},

    { field: 'created_at', headerName: 'Date', width: 180, editable: false,
        valueFormatter: (value) => {
            if (!value) return '';
            const [date, time] = value.split('T');
            const [hours, minutes] = time.split(':');
            return `${date} ${hours}:${minutes}`;
        }
     },
    { field: 'user_name', headerName: 'Created By', width: 150, editable: false },
    { field: 'reference_no', headerName: 'Reference No.', width: 200, editable: true },
    { field: 'tags', headerName: 'Tags', width: 250, editable: true },
    { field: 'status', headerName: 'status', width: 200, editable: false },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={() =>
                setRowModesModel((prev) => ({
                  ...prev,
                  [id]: { mode: GridRowModes.View },
                }))
              }
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              onClick={() =>
                setRowModesModel((prev) => ({
                  ...prev,
                  [id]: { mode: GridRowModes.View, ignoreModifications: true },
                }))
              }
              color="inherit"
            />,
          ];
        }
      
        return [
          <GridActionsCellItem
            icon={<Edit />}
            label="Edit"
            onClick={handleEditClick(id)}
          />,
          /*
          <GridActionsCellItem
            icon={<Delete />}
            label="Delete"
            onClick={handleDeleteClick(id)}
          />,
          */
        ];
      },
    },
  ];


 const handleCopySubItem = (itemId, quoteId) => async () => {
  try {
    const confirmed = await confirmC("Are you going to copy selected quote?");
    if (!confirmed) return;

    await authFetchRequest(`/itemquotes/${itemId}/copy`, null, "POST");

    // Refresh the list of items for the quote to include the new copy
    await fetchItemQuotes(quoteId);

    console.log(`Item ${itemId} copied`);
  } catch (err) {
    console.error("Copy failed:", err);
    await alertC("Failed to copy item: " + err.message);
  }
};

  const handleDeleteSubItem = (itemId) => async () => {
    try {
      const confirmed = await confirmC("Are you sure you want to delete this item?");
      if (!confirmed) return;
  
      await authFetchRequest(`/itemquotes/${itemId}`, null, "DELETE");
  
      // Update local state (e.g. quoteItems) to remove the deleted item
      setItemQuotes(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(quoteId => {
          updated[quoteId] = updated[quoteId].filter(item => item.id !== itemId);
        });
        return updated;
      });
  
      console.log(`Item ${itemId} deleted`);
    } catch (err) {
      console.error("Delete failed:", err);
      await alertC("Failed to delete item: " + err.message);
    }
  };
  
//==>
  // Get current item quotes safely
  const quoteItems = Array.isArray(itemQuotes[expandedRow])
    ? itemQuotes[expandedRow]
    : [];
    //alert(JSON.stringify(quoteItems, null, 2));
  const selectedQuote = quotes.find(q => q.id === expandedRow);
  const fkCustomerId  = selectedQuote?.fkCustomerId;
  const fkUserId      = selectedQuote?.fkUserId;
  const status        = selectedQuote?.status;
  const reference_no  = selectedQuote?.reference_no;
  

  return (    
    <Box justifyContent="space-between" alignItems="center" width="100%">
      {/* Add New Quote Button */}
      <Paper sx={{ p: 2, marginBottom: 2 }}>
      <h3>Orders</h3>
    

    {/* Right Side: Archive Link */}
 
    <Link to="/archive" style={{ textDecoration: 'none' }}>
      <Button variant="outlined" color="secondary">
        View Archive
      </Button>
    </Link>

      </Paper>
      {showCustomerCombo && (
        <div style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', alignItems: 'left', gap: '1rem', marginBottom: '1rem' }}>
          <CmbCustomers
            value={selectedCustomer}
            onChange={handleCustomerChange}
            onAddNew={handleAddNewCustomer}
            customers={customers}
            setCustomers={setCustomers}
          />

          <Button sx={{ width: '100%', maxWidth: '500px', height: '2.5em' }}
              variant="outlined"
              color="primary"
              disabled={!selectedCustomer}
              onClick={handleCreateQuote}
          >
              {selectedCustomer ? `Create Quote for ${selectedCustomer.name}` : 'Create Quote'}
          </Button>
          
          <Button sx={{  height: '2.5em' }}
            variant="outlined"
            color="secondary"
            onClick={() => handleHideClick()}
            >
            Hide
          </Button>
          <NewCustomerDialog
              show={showDialog}
              onClose={() => setShowDialog(false)}
              onCustomerAdded={(newCustomer) => {
              setCustomers(prev => [...prev, newCustomer]);     // Add to combo box
              setSelectedCustomer(newCustomer);                 // Auto-select
            }}
          />
          </div>

        </div>
      )}
      <div style={{ height: 300, width: '100%' }}>
        <DataGrid

          pageSize={10}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          rowsPerPageOptions={[10, 20, 50]} // 👈  dropdown options
          pageSizeOptions={[10, 20, 50]}    // 👈 fallback for older versions
          
          rows={quotes}
          columns={columns}
          getRowId={(row) => row.id}
          rowHeight={30}

          editMode="row"
          rowModesModel={rowModesModel}
          onRowEditStop1={handleRowEditStop}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)} // <-- Add this!
          processRowUpdate={processRowUpdate}
          onRowEditStart={(params) => {
            //console.log('Editing started:', params);
          }}
          onRowEditStop={(params, event) => {
            //console.log('Editing stopped:', params);
            event.defaultMuiPrevented = true;
          }}


          sx={{
            '& .MuiDataGrid-cell': {
              fontSize: '0.95rem',
              fontFamily: 'Arial, sans-serif',
            },
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '1rem',
              fontWeight: 'bold',
            }
          }}
          onRowClick={handleRowClick}
          disableRowSelectionOnClick
        />
      </div>

    {expandedRow && (
    <Collapse in={true} timeout="auto" unmountOnExit>
    <Paper elevation={1} sx={{ mt: 2, p: 2, backgroundColor: '#f9f9f9' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mr={70}>
            <Typography variant="h6" >
                Order #{expandedRow} Details &nbsp;            
            </Typography>
            <MenuView quoteId={expandedRow} fkCustomerId={8}  fkUserId={8} label={'view docs'}/>
        </Box>
      {loadingItemQuotes ? (
        <CircularProgress />
      ) : quoteItems.length > 0 ? (
        <>
          {/* Table layout for better alignment */}
          <table className="table-sm" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>Sub ID</th>
                <th>Item Type</th>
                <th style={{ width: '150px' }}>created at</th>
                <th style={{ width: '150px' }}>updated at</th>

                <th style={{ width: '100px' }}>Subtotal</th>
                <th style={{ width: '100px' }}> Tax</th>
                <th style={{ width: '100px' }}>Total</th>
                <th style={{ width: '50px' }}>Qty</th>
                <th style={{ width: '50px' }}>Edit</th>
                {/*
                <th style={{ width: '50px' }} >Delete</th>
                <th style={{ width: '50px' }} >Copy</th>
                */}
              </tr>
            </thead>
            <tbody>
              {quoteItems.map(item => (
                <tr 
                    key={item.id} 
                    className={selectedRow === item.id ? "selected-row" : "hover-row"}


                    onClick={() => setSelectedRow(item.id)} // ✅ Update selection on row click
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}                  
                >

                  <td>{item.subId}</td>
                  <td>{item?.doorData?.frameData?.selectedDoor?.name}</td>
                  <td>
                    {item?.created_at
                      ? `${item.created_at.split('T')[0]} ${item.created_at.split('T')[1].slice(0, 5)}`
                      : 'N/A'}
                  </td>
                  <td>
                    {item?.updated_at
                      ? `${item.updated_at.split('T')[0]} ${item.created_at.split('T')[1].slice(0, 5)}`
                      : 'N/A'}
                    </td>
                  <td>{item?.doorData?.calc?.subtotal}</td>
                  <td>{item?.doorData?.calc?.tax}</td>
                  <td>{item?.doorData?.calc?.total}</td>
                  <td>{item?.doorData?.frameData?.quantity}</td>
                  <td>
                  {/*console.log('maremala:' + JSON.stringify({item}, null, 2))*/}
                    <Link to={`/${item.itemType}`} state={{ quoteId: item.fkQuoteId, quoteItemId: item.id, 
                                                            fkCustomerId: fkCustomerId, fkUserId: fkUserId, 
                                                            subId: item.subId, reference_no: reference_no  }}>
                      <Tooltip title="Edit Item">
                        <IconButton size="small" color="primary">
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </td>
                  {/*
                  <td style={{ height: '10px' }}>
                  {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote')) && false ? (
                      <Tooltip title="Delete Item">
                        <IconButton size="small" color="primary" onClick={handleDeleteSubItem(item.id)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>   
                    ) : null}                
                  </td>
                  <td style={{ height: '10px' }}>
                  {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote')) & false  ? (
                      <Tooltip title="Copy Item">
                        <ContentCopyIcon size="small" color="primary" onClick={handleCopySubItem(item.id, item.fkQuoteId)}>
                          <ContentCopyIcon fontSize="small" />
                        </ContentCopyIcon>
                      </Tooltip>   
                    ) : null}                
                  </td>
                  */}
                </tr>
              ))}
            </tbody>
          </table>

          {/* AddItem component */}
          {/*console.log('maremela:' + JSON.stringify({expandedRow}, null, 2))*/}
          {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
            <AddItem quoteId={expandedRow} fkCustomerId={fkCustomerId}  fkUserId={fkUserId} reference_no={reference_no} />
          ) : null}  
        </>
      ) : (
        <>
        <Typography variant="body2" color="textSecondary">
          No items found.
        </Typography>
        <div>
        {((parseInt(getCookie('user_id')) === parseInt(fkUserId)) && (status === 'Quote'))  ? (
            <AddItem 
                 quoteId={selectedQuote.id} fkCustomerId={selectedQuote?.fkCustomerId}  fkUserId={selectedQuote?.fkUserId} reference_no={reference_no}
            />
          ) : null} 
        </div>
        </>    
      )}
    </Paper>
  </Collapse>

         )}

    </Box>
  );
};

export default Orders;
